// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__1qw95","icon":"index_icon__3W-BT","name":"index_name__1H4_N"};